import { render, staticRenderFns } from "./AdminUserSecurity.vue?vue&type=template&id=086fbaee&scoped=true&"
import script from "./AdminUserSecurity.vue?vue&type=script&lang=js&"
export * from "./AdminUserSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086fbaee",
  null
  
)

export default component.exports